import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { GmsmenuService } from '../core/services/gmsmenu.service';
import { AuthenticationService } from '../core/services/authentication.service';
import { ConvertsymbolPipe } from '../shared/pipes/convertsymbol.pipe';
import { GmsdialogService } from '../shared/services/gmsdialog.service';
// import { IGmsConfirmData } from '../shared/dialogs/gmsconfirm/gmsconfirm.component';
@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-gms-welcome',
  templateUrl: './gms-welcome.component.html',
  styleUrls: ['./gms-welcome.component.scss']
})
export class GmsWelcomeComponent implements OnInit {
  public navlinksData: any;
  public userName: string = null;
  public arrstr = [['&lt;', "player_count", 4]]
  constructor(private authSer: AuthenticationService, private router: Router, private gmsMenuSer: GmsmenuService, private consympipe: ConvertsymbolPipe, private conser: GmsdialogService) {
    this.navlinksData = this.gmsMenuSer.gmsMenuData;
    let un = sessionStorage.getItem('userName');
    if (un === undefined || un === null) {
      this.userName = this.authSer.userName;
      sessionStorage.setItem("userName", this.userName);
    } else {
      this.userName = un;
    }
  }
  ngOnInit(): void {
  }
  /*
    public test() {
      var confirmData: IGmsConfirmData = {
        message: "delete the record", title: "Record",
        buttons: { cancel: "Close", confirm: "DELETE" },
        actions: {
          cancel: () => { },
          confirm: () => {
            console.log("Delete Btn Pressed");
            this.closeDialog();
          }
        }
      }
      const width = '300px'
      this.conser.showGmsconfirm(confirmData, width).afterClosed().subscribe((reqAction) => {
        console.log('reqAction:', reqAction);
      })
    }
    */

  getMenusData() {
    return Object.keys(this.navlinksData);
  }

  // navigateToGameManagement() {
  //   //  this.router.navigate(['gmsnavmenu', 'gamemanagement']); // working fine
  //   this.router.navigate(['/gmsnavmenu/gamemanagement']);
  //   // this.router.navigate(['/gmsnavmenu']);

  // }
  converSym(reqVal) {
    var str = reqVal.toString();
    console.log(this.consympipe.transform(str));
    return this.consympipe.transform(str);
  }
  navigateToGameManagement(reqMenuName) {
    var navLink = "/gmsnavmenu/" + reqMenuName;
    this.router.navigate([navLink]);
  }
  navigateToChatManagement() {
    this.router.navigate(['/gmsnavmenu/chatmanagement']);
  }
  navigateToDataReports() {
    this.router.navigate(['/gmsnavmenu/datareports']);
  }
  navigateToCustomerService() {
    this.router.navigate(['/gmsnavmenu/customerservices']);
  }
}
